import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/discoveryManage',
        name: '发现管理',
        meta: {
            title: "发现管理",
        },
        redirect: '/discoveryManage/publishList',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/discoveryManage/publishList',
                name: "发布列表",
                meta: {
                    title: "发布列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/discoveryManage/publishList.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/discoveryManage/releaseDetail',
                name: "发布详情",
                meta: {
                    title: "发布详情",
                    isDestroy: true
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/discoveryManage/releaseDetail.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/discoveryManage/commentManage',
                name: "评论管理",
                meta: {
                    title: "评论管理",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/discoveryManage/commentManage.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/discoveryManage/typeManage',
                name: "类型管理",
                meta: {
                    title: "类型管理",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/discoveryManage/typeManage.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]